const templates: Record<string, string> = {
  "bank-statement-parser": "bank-statements",
  "purchase-order-parser": "purchase-orders",
  "invoice-parser": "invoices",
  "receipt-parser": "receipts",
  "document-parser": "document-parser",
  "pdf-to-sqlite": "document-parser",
};
export function demoHrefForSource(source: string): string {
  const template = templates[source.replace(/-demo$/, "")];
  return template
    ? `/demo/${template}?source=${encodeURIComponent(source)}`
    : `/demo?source=${encodeURIComponent(source)}`;
}
